<template>
  <div
    style="text-align: right;"
  >
    <el-dropdown
      ref="dropDown"
      size="small"
      @command="handleAction"
    >
      <el-button
        size="mini"
        class="el-dropdown-link"
        @click.stop="toggleDropDown"
      >
        <i :class="!buttonLoader ? 'el-icon-more' : 'el-icon-loading'" />
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-if="invoice.status === 'recorded'"
          v-can="'invoice.view'"
          :command="preview"
          :disabled="buttonLoader"
        >
          <i class="el-icon-view" /> Előnézet
        </el-dropdown-item>
        <el-dropdown-item
          v-if="invoice.status !== 'recorded' && invoice.invoice_file_url"
          v-can="'invoice.view'"
          :command="openInvoice"
          :disabled="buttonLoader"
        >
          <i class="el-icon-printer" /> Nyomtatás
        </el-dropdown-item>
        <el-dropdown-item
          v-if="invoice.status !== 'recorded'"
          v-can="'invoice.view'"
          :command="openPayments"
          :disabled="buttonLoader"
        >
          <i class="el-icon-coin" /> Befizetések
        </el-dropdown-item>
        <el-dropdown-item
          v-if="invoice.status === 'done' && (invoice.type === 'CREATE' || invoice.type === 'MODIFY')"
          v-can="'invoice.update'"
          :command="confirmStornoInvoice"
          :disabled="buttonLoader"
        >
          <i class="el-icon-error" /> Sztornó
        </el-dropdown-item>
        <el-dropdown-item
          v-if="invoice.status === 'recorded'"
          v-can="'invoice.update'"
          :command="closeInvoice"
          :disabled="buttonLoader"
        >
          <i class="el-icon-check" /> Lezárás
        </el-dropdown-item>
        <el-dropdown-item
          v-can="'invoice.update'"
          :command="updateInvoice"
          :disabled="buttonLoader"
        >
          <i class="el-icon-edit" /> Módosítás
        </el-dropdown-item>
        <el-dropdown-item
          v-if="invoice.status === 'recorded'"
          v-can="'invoice.delete'"
          :command="deleteInvoice"
          :disabled="buttonLoader"
        >
          <i class="el-icon-delete" /> Törlés
        </el-dropdown-item>
        <el-dropdown-item
          v-if="invoice.status !== 'recorded'"
          v-can="'invoice.view'"
          :command="sendInvoice"
          :disabled="buttonLoader"
        >
          <i class="el-icon-message" /> Küldés Emailben
        </el-dropdown-item>
        <el-dropdown-item
          v-if="invoice.nav_status === 'processing'"
          v-can="'invoice.set_nav_status_to_success'"
          :command="openSetNavStatusToSuccessDialog"
          :disabled="buttonLoader"
        >
          <i class="el-icon-check" />Már történt sikeres NAV szinkron
        </el-dropdown-item>
        <el-dropdown-item
          v-if="invoice.status === 'done'"
          v-can="'invoice.update'"
          :command="openDeleteInvoiceImageDialog"
          :disabled="buttonLoader"
        >
          <i class="el-icon-warning" />Számlakép törlése
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <storno-dialog
      v-if="isStornoDialogShown"
      :invoice-id="invoice.id"
      :invoice-number="invoice.invoice_number"
      @close="stornoInvoice"
    />
  </div>
</template>

<script>
import StornoDialog from './StornoDialog';

export default {
  components: {
    StornoDialog
  },
  props: ['invoice'],
  data() {
    return {
      isStornoDialogShown: false,
      buttonLoader: false,
    };
  },
  methods: {
    handleAction(action) {
      action();
    },
    toggleDropDown() {
      this.$refs['dropDown'].visible = !this.$refs['dropDown'].visible;
    },
    openPayments() {
      this.$router.push('/sales/invoices/payments/' + this.invoice.id);
    },
    confirmStornoInvoice() {
      this.isStornoDialogShown = true
    },
    async stornoInvoice(status) {
      this.isStornoDialogShown = false
      if (true === status) {
        this.buttonLoader = true;
        try {
          await this.$store.dispatch('invoice/storno', this.invoice.id);
          this.$store.dispatch('invoice/fetchAll');
        } catch (e) {
        }
        this.buttonLoader = false;
      }
    },
    async deleteInvoice() {
      this.buttonLoader = true;
      try {
        await this.$store.dispatch('invoice/delete', this.invoice.id);
        this.$store.dispatch('invoice/fetchAll');
      } catch (e) {
      }
      this.buttonLoader = false;
    },
    async updateInvoice() {
      this.$router.push('/sales/invoices/update/' + this.invoice.id);
    },

     openSetNavStatusToSuccessDialog() {
        this.$confirm('Ez a folyamat nem visszafordítható, a számla NAV státusza "Elküldve" lesz.', 'Biztosan átállítja a státuszt? ', {
          confirmButtonText: 'Igen',
          cancelButtonText: 'Mégse',
          type: 'warning',
        })
        .then(() => {
          this.setNavStatusToSuccess();
        })
        .catch(() => {
          this.$router.replace('/sales/invoices/');
        });
      },

    async setNavStatusToSuccess() {
       this.buttonLoader = true;
      try {
        await this.$store.dispatch('invoice/setNavStatusToSuccess', this.invoice.id);
        this.$store.dispatch('invoice/fetchAll');
      } catch (e) {
        console.error(e)
      }
      this.buttonLoader = false;
    },

    openDeleteInvoiceImageDialog() {
      this.$confirm('Számlakép törlése', 'Biztosan törli a számlaképet?', '', {
        confirmButtonText: 'Igen',
        cancelButtonText: 'Mégse',
        type: 'warning',
      })
      .then(() => {
        this.deleteInvoiceImage();
      })
      .catch(() => {
        this.$router.replace('/sales/invoices/');
      });
    },

    async deleteInvoiceImage() {
       this.buttonLoader = true;
      try {
        await this.$store.dispatch('invoice/deleteInvoiceImage', this.invoice.id);
        this.$store.dispatch('invoice/fetchAll');
      } catch (e) {
        console.error(e)
      }
      this.buttonLoader = false;
    },

    async closeInvoice() {
      this.buttonLoader = true;
      try {
        await this.$store.dispatch('invoice/close', this.invoice.id);
        this.$store.dispatch('invoice/fetchAll');
      } catch (e) {
      }
      this.buttonLoader = false;
    },
    async preview() {
      this.buttonLoader = true;
      const response = await axios.get('api/invoices/preview/' + this.invoice.id, {
        responseType: 'arraybuffer',
        headers: {
          'Accept': 'application/pdf'
        },
      });
      this.buttonLoader = false;

      const newBlob = new Blob([response], { type: 'application/pdf' });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      const data = window.URL.createObjectURL(newBlob);
      window.open(data);
    },
    async openInvoice() {
      if (this.invoice.invoice_file_url) {
        this.buttonLoader = true;
        try {
          const url = await axios.get('api/files?path=' + this.invoice.invoice_file_url);
          window.open(url);
        } catch (e) {
        }
        this.buttonLoader = false;
      }
    },
    async sendInvoice() {
      this.buttonLoader = true;
      try {
        const response = await axios.get('api/invoices/send/' + this.invoice.id);
        this.buttonLoader = false;
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>
